import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
`;

export const ImageSmoothStyled = styled.div`
  .img_smooth_wrap {
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16 / 9"};
    background: #ebebeb;
    overflow: hidden;
    animation: ${pulse} 1.5s ease-in-out infinite;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0;
      transition: opacity 0.4s ease-in-out;
    }
    &.loaded {
      animation: none;
      background: transparent;
      img {
        opacity: 1;
      }
    }
  }
`;
